import * as React from 'react'

import styled from 'styled-components'
import { useSpring, animated } from 'react-spring'
import { Bell } from '@geist-ui/react-icons'
import { useAtom } from 'jotai'
import { rwNotificationFeedAtom } from '../../atoms/Notifications'
import { GetNotificationFeed, MarkNotificationsRead } from '../../data/Notifications'
import useAuth from '../../hooks/auth'
import { useEffect, useState } from 'react'
import { db } from '../../data/FirebaseUtils'

const OuterDiv = styled(animated.div)`
  display: flex;
  align-items: center;
  flex-direction: row;
  border-radius: 50%;
  background: #101010;
  border-width: 1px;
  border-color: #aaa;
  border-style: solid;
  padding: 8px;
  cursor: pointer;
  margin-right: 15px;

  @media (min-width: 62em) {
    margin-left: 15px;
  }
`

const Circle = styled.div`
  position: absolute;
  z-index: 1;
  top: -1px;
  right: -6px;
  padding: 1px 6px;
  border-radius: 50%;
  background: rgb(255, 69, 58);
  font-size: 12px;
  color: white;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
`

const NotificationButton = (): JSX.Element => {
  const [notificationHover, setNotificationHover] = useState(false)
  const [, setOpen] = useAtom(rwNotificationFeedAtom)
  const { profile } = useAuth()
  const [unread, setUnread] = useState(0)

  const [hasContactEmail, setHasContactEmail] = useState(true)

  useEffect(() => {
    const address = profile?.address

    if (address) {
      db.secrets(address)
        .doc('confidential')
        .onSnapshot((doc) => {
          if (doc.exists) {
            const data = doc.data()
            if (data) {
              setHasContactEmail(data['email'] !== undefined)
            } else {
              setHasContactEmail(false)
            }
          } else {
            setHasContactEmail(false)
          }
        })
    }
  }, [profile?.address])

  const notificationHoverState = useSpring({
    boxShadow: notificationHover
      ? '0px 5px 25px rgba(255,255,255,0.2)'
      : '0px 0px 0px rgba(0,0,0,0)',
    transform: notificationHover ? `translate3d(0,-5%,0)` : `translate3d(0,0%,0)`,
    config: {
      mass: 1,
      tension: 170,
      friction: 26,
      velocity: 0,
    },
  })

  const getNotificationStats = async (address: string): Promise<void> => {
    const resp = await GetNotificationFeed(address, 0, 0)
    setUnread(resp.unread)
  }

  const markUnread = async (): Promise<void> => {
    setUnread(0)
    setOpen(profile ? profile.address : undefined)
    await MarkNotificationsRead(profile?.address ?? '')
  }

  useEffect(() => {
    if (profile) {
      getNotificationStats(profile.address)
    }
  }, [profile])

  return (
    <OuterDiv
      style={notificationHoverState}
      onMouseEnter={() => setNotificationHover(true)}
      onMouseLeave={() => setNotificationHover(false)}
      onClick={markUnread}
    >
      {unread > 0 && <Circle>{unread}</Circle>}
      {!hasContactEmail && unread == 0 && <InfoCircleBadge>{'!'}</InfoCircleBadge>}
      <Bell size={25} />
    </OuterDiv>
  )
}

export default NotificationButton

const InfoCircleBadge = styled.div`
  position: absolute;
  z-index: 1;
  top: -1px;
  right: -6px;
  padding: 1px 6px;
  border-radius: 100%;
  background: rgb(239, 174, 43);
  font-size: 12px;
  color: white;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
`
